import styled from "styled-components";

export const List = styled.div`
  border-radius: 3px;
  overflow-x: auto;
  border-bottom: none;
`;
export const ListRow = styled.div`
  display: flex;
  justify-content: space-between;
  & span {
    text-align: center;
    padding: 3px 16px;
    min-width: fit-content;
  }
  & .title-row {
    display: block;
    text-align: start;
    max-width: 360px;
    min-width: 210px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
  }
`;
